import template from './LidButton.template.html';
import templateRefer from './lid.template.html';

export default {
  template,
  bindings: {
    showLogo: '<',
    contact: '<',
    owner: '<',
    idTicket: '<',
    idWorkflow: '<',
    loanAmount: '<',
    isDisabled: '<'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdDialog,
      $mdMedia,
      eventService,
      dateTimeService,
      helperService,
      lidService,
      LID
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;

      ctrl.initialize = () => {
        ctrl.contact = ctrl.contact || {};
        ctrl.owner = ctrl.owner || {};
        ctrl.idTicket = ctrl.idTicket || {};
        ctrl.idWorkflow = ctrl.idWorkflow || {};
        ctrl.loanAmount = ctrl.loanAmount || {};
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: null,
            locals: {
              contact: ctrl.contact,
              owner: ctrl.owner,
              idTicket: ctrl.idTicket,
              idWorkflow: ctrl.idWorkflow,
              loanAmount: ctrl.loanAmount,
              isDisabled: ctrl.isDisabled
            },
            template: templateRefer,
            controllerAs: '$ctrl',
            controller(contact, owner, idTicket, idWorkflow, loanAmount, isDisabled) {
              const self = this;
              self.currentTimeZone = $rootScope.CurrentTimeZone();
              self.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
              self.currentCurrency = $rootScope.CurrentCurrency();
              self.availableSmokingTypes = LID.QUESTIONS.YES_NO;
              self.availableGenderTypes = LID.QUESTIONS.GENDER;
              self.availableQuoteTypes = LID.QUESTIONS.QUOTE_TYPE;
              self.hours = LID.QUESTIONS.HOURS;
              ctrl.availableStates = helperService.getAvailableAddressStates();

              self.contact = contact;
              self.owner = owner;
              self.idTicket = idTicket;
              self.idWorkflow = idWorkflow;
              self.loanAmount = loanAmount;
              self.isDisabled = isDisabled;
              self.errorMessages = [];
              self.hasError = false;
              self.isLoading = null;
              self.url = '';
              self.result = false;

              self.date = '';
              const initialTime = self.hours[0];
              self.time = initialTime;
              self.Model = {
                st: {
                  idContact: self.contact?.id || '',
                  idTicket: self.idTicket || '',
                  idWorkflow: self.idWorkflow || '',
                  idOwner: self.owner?.id || ''
                },
                first_name: self.contact?.person?.information?.firstName || '',
                last_name: self.contact?.person?.information?.familyName || '',
                smoking: 'No',
                state: self.contact?.person?.contact?.address?.state || '',
                gender:
                  self.contact?.person?.information?.gender?.name === 'male'
                    ? 'Male'
                    : 'Female',
                email: self.contact?.person?.contact?.email || '',
                dob: self.contact?.person?.information?.dateOfBirth
                  ? moment
                      .utc(self.contact.person.information.dateOfBirth, 'X')
                      .format('DD/MM/YYYY')
                  : '',
                age: self.contact?.person?.information?.dateOfBirth
                  ? moment().diff(
                      moment.utc(self.contact.person.information.dateOfBirth, 'X'),
                      'years'
                    )
                  : '',
                mobile: self.contact?.person?.contact?.primary?.replace(/\s/g, '') || '',
                quote_type: 'Life Insurance',
                additional_info: '',
                contact_date_time: '',
                occupation: 'adminclerk',
                life_sum: self.loanAmount || 0,
                tpd_sum: 0,
                tpd_definition: '',
                trauma_sum: 0,
                annual_income: 0,
                ip: '',
                accident_only: 'No'
              };

              self.isDateInThePast = () => {
                const contactDateTime = _.isNumber(self.date)
                  ? self.date
                  : dateTimeService.epoch(self.date);
                const isDateInThePast = dateTimeService
                  .getMoment(contactDateTime)
                  .endOf('day')
                  .isBefore(dateTimeService.getMoment(dateTimeService.epoch()));

                if (isDateInThePast) {
                  if (!self.hasError) {
                    self.hasError = true;
                    self.errorMessages.push(
                      'Life insurance direct errors:',
                      'The scheduled call back date is in the past.'
                    );
                  }
                } else {
                  self.hasError = false;
                  self.errorMessages = [];
                }
                return isDateInThePast;
              };

              self.canSend = () => {
                if (
                  !self.Model.first_name ||
                  !self.Model.last_name ||
                  !self.Model.email ||
                  !self.Model.dob ||
                  !self.Model.mobile ||
                  self.Model.mobile?.length !== 10 ||
                  !self.Model.state ||
                  !self.Model.gender ||
                  !self.Model.age ||
                  !self.Model.life_sum ||
                  (self.date !== '' && !self.time.value) ||
                  self.isDateInThePast()
                ) {
                  return false;
                }

                return !self.isDisabled;
              };

              self.setTime = () => {
                self.Model.contact_date_time = self.date ? self.date + self.time.value : '';
                self.Model.contact_date_time = self.Model.contact_date_time
                  ? moment.utc(self.Model.contact_date_time, 'X').format('DD/MM/YYYY hh:mm A')
                  : '';
              };

              dateTimeService.getSet(self, self, 'date', 'getSetContactDateTime');

              self.sending = false;
              self.response = null;

              self.cancel = () => {
                $mdDialog.cancel();
              };

              self.confirm = () => {
                window.open(self.url, '__blank');
                $mdDialog.hide();
              };

              self.refer = async () => {
                self.setTime();
                self.errorMessages = [];
                self.hasError = false;
                self.isLoading = true;

                lidService.send(self.Model).then((result) => {
                  self.isLoading = false;
                  if (result?.status) {
                    self.url = result?.payload?.quotes_url;
                    self.result = true;
                  } else {
                    self.hasError = true;
                    if (result?.errors?.length) {
                      const len = result?.errors?.length || 0;
                      for (let e = 0; e < len; e += 1) {
                        const error = result?.errors[e];
                        const message = error?.label
                          ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                          : error?.message || error || '';
                        self.errorMessages.push(message);
                      }
                    } else {
                      self.errorMessages.push(result?.errorMessage);
                    }
                    self.errorMessages.unshift('Life insurance direct errors:');
                  }
                });
              };
            }
          })
          .then(() => {
            //
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
